<template>
    <div class="integrations-view row">
        <b-card-group deck>
            <div class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="API" class="white-card account-card">
                    <api-key-input :allow-regenerate="!user.User_Id" />
                </b-card>
            </div>
            <div class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="remove.bg API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onRemoveBgSubmit()">
                        <b-form-group id="remove-bg-input" label="API Key" label-for="remove-bg-input">
                            <b-input-group>
                                <b-form-input
                                    id="remove-bg-input"
                                    v-model="removeBgApiKey"
                                    :type="showFields.removeBg ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.removeBg = !showFields.removeBg"
                                        ><font-awesome-icon
                                            :icon="showFields.removeBg ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text class="link">
                                API Key to use remove.bg services with Customily. Get it
                                <a href="https://www.remove.bg/api" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn variant="outline-primary" @click="openRateLimitModal('RemoveBg', 'remove.bg')">
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-3"
                                variant="primary"
                                :loading="savingState.removeBg"
                                :disabled="!modifiedRemoveBgApiKey"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex justify-content-center align-self-start mt-3">
                <b-card title="VanceAI API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onVanceAiSubmit()">
                        <b-form-group id="vanceAi-input" label="API Key" label-for="vanceAi-input">
                            <b-input-group>
                                <b-form-input
                                    id="vanceAi-input"
                                    v-model="vanceAiApiKey"
                                    :type="showFields.vanceAi ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.vanceAi = !showFields.vanceAi"
                                        ><font-awesome-icon
                                            :icon="showFields.vanceAi ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text class="link">
                                API Key to use VanceAI services with Customily. Get it
                                <a href="https://vanceai.com/api/?source=top_apibtn" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <loader-btn class="float-right" type="submit" variant="primary" :loading="savingState.vanceAi">
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex justify-content-center align-self-start mt-3">
                <b-card title="OpenAI API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onOpenAiSubmit()">
                        <b-form-group id="openAi-input" label="API Key" label-for="openAi-input">
                            <b-input-group>
                                <b-form-input
                                    id="openAi-input"
                                    v-model="openAiApiKey"
                                    :state="openAiApiKeyState"
                                    aria-describedby="openAi-input-help openAi-input-feedback"
                                    trim
                                    :type="showFields.openAi ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.openAi = !showFields.openAi"
                                        ><font-awesome-icon
                                            :icon="showFields.openAi ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text text-variant="danger">
                                {{ openAiError }}
                            </b-form-text>
                            <b-form-text class="link">
                                API Key to use OpenAI services with Customily. Get it
                                <a href="https://platform.openai.com/api-keys" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn variant="outline-primary" @click="openRateLimitModal('OpenAi', 'OpenAI')">
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-3"
                                :disabled="!openAiVerified"
                                variant="primary"
                                :loading="savingState.openAi"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex justify-content-center mt-3">
                <b-card title="Spotify API Credentials" class="white-card account-card">
                    <b-form @submit.stop.prevent="onSpotifyCredentialsSubmit()">
                        <b-form-group id="spotify-client-id" label="Client ID" label-for="spotify-client-id-input">
                            <b-input-group>
                                <b-form-input
                                    id="spotify-client-id-input"
                                    v-model="spotifyClientID"
                                    :type="showFields.spotifyClientId ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn
                                        variant="link"
                                        @click="showFields.spotifyClientId = !showFields.spotifyClientId"
                                        ><font-awesome-icon
                                            :icon="showFields.spotifyClientId ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group
                            id="spotify-client-secret"
                            label="Client Secret"
                            label-for="spotify-client-secret-input"
                        >
                            <b-input-group>
                                <b-form-input
                                    id="spotify-client-secret-input"
                                    v-model="spotifyClientSecret"
                                    :type="showFields.spotifyClientSecret ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn
                                        variant="link"
                                        @click="showFields.spotifyClientSecret = !showFields.spotifyClientSecret"
                                        ><font-awesome-icon
                                            :icon="
                                                showFields.spotifyClientSecret ? ['far', 'eye-slash'] : ['far', 'eye']
                                            "
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <loader-btn
                            class="float-right ml-3"
                            type="submit"
                            variant="primary"
                            :loading="savingState.spotifyCredentials"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="Cutout.pro API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onCutoutProSubmit()">
                        <b-form-group id="cutout-pro-input" label="API Key" label-for="cutout-pro-input">
                            <b-input-group>
                                <b-form-input
                                    id="cutout-pro-input"
                                    v-model="cutoutProApiKey"
                                    :type="showFields.cutoutPro ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.cutoutPro = !showFields.cutoutPro"
                                        ><font-awesome-icon
                                            :icon="showFields.cutoutPro ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text text-variant="danger">
                                {{ cutoutProError }}
                            </b-form-text>
                            <b-form-text class="link">
                                API Key to use cutout.pro services with Customily. Get it
                                <a href="https://www.cutout.pro/api" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn variant="outline-primary" @click="openRateLimitModal('CutoutPro', 'Cutout.pro')">
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-3"
                                variant="primary"
                                :loading="savingState.cutoutPro"
                                :disabled="!modifiedCutoutProApiKey"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex justify-content-center mt-3">
                <b-card title="Wilcom embroidery credentials" class="white-card account-card">
                    <b-form @submit.stop.prevent="onWilcomCredentialsSubmit()">
                        <b-form-group id="wilcom-app-id" label="App ID" label-for="wilcom-app-id-input">
                            <b-input-group>
                                <b-form-input
                                    id="wilcom-app-id-input"
                                    v-model="wilcomAppId"
                                    :type="showFields.wilcomAppId ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.wilcomAppId = !showFields.wilcomAppId"
                                        ><font-awesome-icon
                                            :icon="showFields.wilcomAppId ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group id="wilcom-app-key" label="App Key" label-for="wilcom-app-key-input">
                            <b-input-group>
                                <b-form-input
                                    id="wilcom-app-key-input"
                                    v-model="wilcomAppKey"
                                    :type="showFields.wilcomAppKey ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.wilcomAppKey = !showFields.wilcomAppKey"
                                        ><font-awesome-icon
                                            :icon="showFields.wilcomAppKey ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <loader-btn
                            class="float-right ml-4"
                            type="submit"
                            variant="primary"
                            :loading="savingState.wilcomCredentials"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>
            <div class="col-6 d-flex justify-content-center mt-3">
                <b-card title="Melco embroidery credentials" class="white-card account-card">
                    <b-form @submit.stop.prevent="onMelcoCredentialsSubmit()">
                        <b-form-group id="melco-username" label="Melco Username" label-for="melco-username-input">
                            <b-input-group>
                                <b-form-input
                                    id="melco-username-input"
                                    v-model="melcoUsername"
                                    :type="showFields.melcoUsername ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.melcoUsername = !showFields.melcoUsername"
                                        ><font-awesome-icon
                                            :icon="showFields.melcoUsername ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group id="melco-api-key" label="Melco Api Key" label-for="melco-api-key-input">
                            <b-input-group>
                                <b-form-input
                                    id="melco-api-key-input"
                                    v-model="melcoApiKey"
                                    :type="showFields.melcoApiKey ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.melcoApiKey = !showFields.melcoApiKey"
                                        ><font-awesome-icon
                                            :icon="showFields.melcoApiKey ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                        <loader-btn
                            class="float-right ml-3"
                            type="submit"
                            variant="primary"
                            :loading="savingState.melcoCredentials"
                            loading-text="Saving"
                        >
                            Save
                        </loader-btn>
                    </b-form>
                </b-card>
            </div>
            <div v-if="user?.CanvaAccessToken?.length" class="col-6 d-flex justify-content-center mt-3 h-fit-content">
                <div class="card white-card account-card">
                    <div class="card-body">
                        <h4 class="card-title">Canva API</h4>
                        <loader-btn
                            class="float-right ml-4"
                            type="submit"
                            variant="danger"
                            loading-text="Diconnecting"
                            :loading="savingState.canvaCredentials"
                            @click="diconnectUserFromCanva"
                        >
                            Disconnect
                        </loader-btn>
                    </div>
                </div>
            </div>
            <div v-if="isImageEffectsEnabled" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="Google Gemini API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onGoogleGeminiApiSubmit()">
                        <b-form-group id="gemini-api-input" label="API Key" label-for="gemini-api-input">
                            <b-input-group>
                                <b-form-input
                                    id="gemini-api-input"
                                    v-model="googleGeminiApiKey"
                                    :type="showFields.googleGemini ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.googleGemini = !showFields.googleGemini"
                                        ><font-awesome-icon
                                            :icon="showFields.googleGemini ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text text-variant="danger">
                                {{ googleGeminiError }}
                            </b-form-text>
                            <b-form-text class="link">
                                API Key to use Google Gemini services with Customily. Get it
                                <a href="https://aistudio.google.com/apikey" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn
                                variant="outline-primary"
                                @click="openRateLimitModal('GoogleGemini', 'Google Gemini')"
                            >
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-3"
                                variant="primary"
                                :loading="savingState.googleGemini"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div v-if="isImageEffectsEnabled" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="OpenRouter API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onOpenRouterApiSubmit()">
                        <b-form-group id="open-router-input" label="API Key" label-for="open-router-input">
                            <b-input-group>
                                <b-form-input
                                    id="open-router-input"
                                    v-model="openRouterApiKey"
                                    :type="showFields.openRouter ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.openRouter = !showFields.openRouter"
                                        ><font-awesome-icon
                                            :icon="showFields.openRouter ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text text-variant="danger">
                                {{ openRouterError }}
                            </b-form-text>
                            <b-form-text class="link">
                                API Key to use OpenRouter services with Customily. Get it
                                <a href="https://openrouter.ai/settings/keys" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn variant="outline-primary" @click="openRateLimitModal('OpenRouter', 'OpenRouter')">
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-4"
                                variant="primary"
                                :loading="savingState.openRouter"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
            <div v-if="isImageEffectsEnabled" class="col-6 d-flex flex-wrap justify-content-center mt-3">
                <b-card title="PicWish API" class="white-card account-card">
                    <b-form @submit.stop.prevent="onPicWishApiSubmit()">
                        <b-form-group id="picwish-input" label="API Key" label-for="picwish-input">
                            <b-input-group>
                                <b-form-input
                                    id="picwish-input"
                                    v-model="picWishApiKey"
                                    :type="showFields.picWish ? 'text' : 'password'"
                                />
                                <b-input-group-append>
                                    <b-btn variant="link" @click="showFields.picWish = !showFields.picWish"
                                        ><font-awesome-icon
                                            :icon="showFields.picWish ? ['far', 'eye-slash'] : ['far', 'eye']"
                                    /></b-btn>
                                </b-input-group-append>
                            </b-input-group>
                            <b-form-text text-variant="danger">
                                {{ picWishError }}
                            </b-form-text>
                            <b-form-text class="link">
                                API Key to use PicWish services with Customily. Get it
                                <a href="https://picwish.com/my-account?subRoute=api-key" target="_blank">here</a>.
                            </b-form-text>
                        </b-form-group>

                        <div class="d-flex justify-content-end">
                            <b-btn variant="outline-primary" @click="openRateLimitModal('Picwish', 'PicWish')">
                                Set Rate Limit
                            </b-btn>
                            <loader-btn
                                type="submit"
                                class="ml-3"
                                variant="primary"
                                :loading="savingState.picWish"
                                loading-text="Saving"
                            >
                                Save
                            </loader-btn>
                        </div>
                    </b-form>
                </b-card>
            </div>
        </b-card-group>

        <api-rate-limit-modal
            v-model="showRateLimitModal"
            :provider="activeRateLimit.provider"
            :provider-label="activeRateLimit.label"
            :attempts-per-ip="activeRateLimit.attemptsPerIp"
            :retry-after-minutes="activeRateLimit.retryAfterMinutes"
            @saved="onRateLimitSaved"
        />
    </div>
</template>

<script lang="ts" setup>
import {
    setWilcomCredentials,
    setMelcoCredentials,
    setOpenAiApiKey,
    setRemoveBgApiKey,
    setVanceAiApiKey,
    setCutoutProApiKey,
    setSpotifyCredentials,
    deleteCanvaCredentials,
    setGoogleGeminiApiKey,
    setOpenRouterApiKey,
    setPicWishApiKey,
    getRateLimits,
    type RateLimitDto
} from '@/api/user';
import { CustomilyUser } from '@/typings/user';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import ApiKeyInput from '@/components/ApiKeyInput/ApiKeyInput.vue';
import ApiRateLimitModal from '@/components/Integrations/ApiRateLimitModal.vue';
import store from '@/store';
import { computed, onBeforeMount, reactive, ref } from 'vue';
import { AxiosError } from 'axios';

const emit = defineEmits<{
    (event: 'user-updated'): void;
}>();

const isImageEffectsEnabled = process.env.VUE_APP_IMAGE_EFFECTS_ENABLED === 'true';

const removeBgApiKey = ref('');
const wilcomAppId = ref('');
const wilcomAppKey = ref('');
const melcoUsername = ref('');
const melcoApiKey = ref('');
const cutoutProApiKey = ref('');
const cutoutProError = ref('');
const googleGeminiError = ref('');
const openRouterError = ref('');

const vanceAiApiKey = ref('');
const openAiApiKey = ref('');
const openAiApiKeyState = ref<boolean | null>(null);
const openAiError = ref('');

const spotifyClientID = ref('');
const spotifyClientSecret = ref('');

const googleGeminiApiKey = ref('');
const openRouterApiKey = ref('');

const picWishApiKey = ref('');
const picWishError = ref('');

const rateLimits = ref<Record<string, RateLimitDto>>({});
const showRateLimitModal = ref(false);
const activeRateLimit = ref<RateLimitDto & { label: string }>({
    provider: '',
    label: '',
    attemptsPerIp: null,
    retryAfterMinutes: null
});

const openRateLimitModal = (provider: string, label: string) => {
    const existing = rateLimits.value[provider];
    activeRateLimit.value = {
        provider,
        label,
        attemptsPerIp: existing?.attemptsPerIp ?? null,
        retryAfterMinutes: existing?.retryAfterMinutes ?? null
    };
    showRateLimitModal.value = true;
};

const onRateLimitSaved = async () => {
    try {
        const list = await getRateLimits();
        rateLimits.value = Object.fromEntries(list.map((r) => [r.provider, r]));
    } catch {
        // ignore — modal already closed, stale values are acceptable
    }
};

const showFields = reactive({
    removeBg: false,
    vanceAi: false,
    openAi: false,
    spotifyClientId: false,
    spotifyClientSecret: false,
    cutoutPro: false,
    wilcomAppId: false,
    wilcomAppKey: false,
    melcoUsername: false,
    melcoApiKey: false,
    googleGemini: false,
    openRouter: false,
    picWish: false
});

const savingState = reactive({
    vanceAi: false,
    removeBg: false,
    wilcomCredentials: false,
    melcoCredentials: false,
    openAi: false,
    cutoutPro: false,
    spotifyCredentials: false,
    canvaCredentials: false,
    googleGemini: false,
    openRouter: false,
    picWish: false
});

const user = computed((): CustomilyUser => store.state.user!);
const openAiVerified = computed(() => {
    if (!openAiApiKey.value) {
        return true;
    }
    return (
        typeof openAiApiKey.value === 'string' && openAiApiKey.value.length > 0 && openAiApiKey.value.startsWith('sk')
    );
});

const modifiedRemoveBgApiKey = computed(() => user.value.RemoveBgAPIKey != removeBgApiKey.value);
const modifiedCutoutProApiKey = computed(() => user.value.CutoutproAPIKey != cutoutProApiKey.value);

onBeforeMount(async () => {
    removeBgApiKey.value = user.value.RemoveBgAPIKey || '';
    vanceAiApiKey.value = user.value.VanceAiAPIKey || '';
    openAiApiKey.value = user.value.OpenAiAPIKey || '';
    melcoUsername.value = user.value.MelcoUsername || '';
    melcoApiKey.value = user.value.MelcoApiKey || '';
    wilcomAppId.value = user.value.WilcomAppId || '';
    wilcomAppKey.value = user.value.WilcomAppKey || '';
    cutoutProApiKey.value = user.value.CutoutproAPIKey || '';
    spotifyClientID.value = user.value.SpotifyClientID || '';
    spotifyClientSecret.value = user.value.SpotifyClientSecret || '';
    googleGeminiApiKey.value = user.value.GoogleGeminiAPIKey || '';
    openRouterApiKey.value = user.value.OpenRouterAPIKey || '';
    picWishApiKey.value = user.value.PicWishAPIKey || '';

    try {
        const list = await getRateLimits();
        rateLimits.value = Object.fromEntries(list.map((r) => [r.provider, r]));
    } catch {
        // non-critical — rate limit buttons still open the modal, just without pre-filled values
    }
});

const onRemoveBgSubmit = async () => {
    try {
        savingState.removeBg = true;
        await setRemoveBgApiKey(removeBgApiKey.value);
    } finally {
        savingState.removeBg = false;
        emit('user-updated');
    }
};

const onVanceAiSubmit = async () => {
    savingState.vanceAi = true;
    await setVanceAiApiKey(vanceAiApiKey.value);
    savingState.vanceAi = false;
    emit('user-updated');
};

const onOpenAiSubmit = async () => {
    savingState.openAi = true;
    try {
        await setOpenAiApiKey(openAiApiKey.value);
        openAiApiKeyState.value = true;
        openAiError.value = '';
        emit('user-updated');
    } catch (error) {
        openAiApiKeyState.value = false;
        openAiError.value = (error as Error).message;
    } finally {
        savingState.openAi = false;
    }
};

const onWilcomCredentialsSubmit = async () => {
    try {
        savingState.wilcomCredentials = true;
        await setWilcomCredentials(wilcomAppId.value, wilcomAppKey.value);
    } finally {
        savingState.wilcomCredentials = false;
        emit('user-updated');
    }
};

const onMelcoCredentialsSubmit = async () => {
    try {
        savingState.melcoCredentials = true;
        await setMelcoCredentials(melcoUsername.value, melcoApiKey.value);
    } finally {
        savingState.melcoCredentials = false;
        emit('user-updated');
    }
};

const onCutoutProSubmit = async () => {
    try {
        savingState.cutoutPro = true;
        cutoutProError.value = '';
        await setCutoutProApiKey(cutoutProApiKey.value);
        emit('user-updated');
    } catch (error) {
        cutoutProError.value = (error as AxiosError).response?.data?.Message;
    } finally {
        savingState.cutoutPro = false;
    }
};

const onSpotifyCredentialsSubmit = async () => {
    try {
        savingState.spotifyCredentials = true;
        await setSpotifyCredentials(spotifyClientID.value, spotifyClientSecret.value);
    } finally {
        savingState.spotifyCredentials = false;
        emit('user-updated');
    }
};

const diconnectUserFromCanva = async () => {
    try {
        savingState.canvaCredentials = true;
        await deleteCanvaCredentials();
    } finally {
        savingState.canvaCredentials = false;
        emit('user-updated');
    }
};

const onGoogleGeminiApiSubmit = async () => {
    try {
        savingState.googleGemini = true;
        googleGeminiError.value = '';
        await setGoogleGeminiApiKey(googleGeminiApiKey.value);
    } catch (error) {
        googleGeminiError.value = (error as Error).message;
    } finally {
        savingState.googleGemini = false;
        emit('user-updated');
    }
};

const onOpenRouterApiSubmit = async () => {
    try {
        savingState.openRouter = true;
        openRouterError.value = '';
        await setOpenRouterApiKey(openRouterApiKey.value);
    } catch (error) {
        openRouterError.value = (error as Error).message;
    } finally {
        savingState.openRouter = false;
        emit('user-updated');
    }
};
const onPicWishApiSubmit = async () => {
    try {
        savingState.picWish = true;
        picWishError.value = '';
        await setPicWishApiKey(picWishApiKey.value);
    } catch (error) {
        picWishError.value = (error as Error).message;
    } finally {
        savingState.picWish = false;
        emit('user-updated');
    }
};
</script>

<style lang="scss" scoped>
.btn-link:focus,
.btn-link:active,
.btn-link:hover {
    box-shadow: none;
    text-decoration: none;
}

.h-fit-content {
    height: fit-content;
}

.confirmation-message {
    display: flex;
    min-height: 200px;
}

.card-with-input {
    .card-body {
        max-width: 440px;
    }
    input {
        min-width: 400px;
    }
}
</style>
